// Gate a loading flag so a fast async op never flashes its loader. Returns true
// only once `loading` has stayed true for `delayMs` — a response that resolves
// sooner shows nothing, so the spinner/skeleton never blinks. Resets the instant
// loading clears.

import { useEffect, useState } from "react";

export function useDelayedLoading(loading: boolean, delayMs = 200): boolean {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!loading) {
      setShow(false);
      return;
    }
    const t = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(t);
  }, [loading, delayMs]);
  return show;
}
